import React from "react";
import { Form } from "react-bootstrap";

const DEMO_LOGO_URL = `${process.env.PUBLIC_URL || ""}/demo-logo.png`;

/**
 * Standalone login screen (used on /login).
 */
export default function Login({
  username,
  password,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
}) {
  return (
    <div className="login-container">
      <div className="login-card">
        <img src={DEMO_LOGO_URL} alt="" className="app-brand-logo app-brand-logo--login" width={64} height={64} />
        <h1 className="login-title">Σύστημα Καταχώρησης</h1>
        <p className="login-subtitle">Συνδεθείτε για πρόσβαση στο σύστημα</p>
        <Form onSubmit={onSubmit} className="login-form" autoComplete="off">
          <div className="form-group">
            <label>Όνομα Χρήστη</label>
            <input
              type="text"
              placeholder="Εισάγετε το όνομα χρήστη"
              value={username}
              onChange={(e) => onUsernameChange(e.target.value)}
              autoComplete="off"
              required
            />
          </div>
          <div className="form-group">
            <label>Κωδικός Πρόσβασης</label>
            <input
              type="password"
              placeholder="Εισάγετε τον κωδικό"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>
          <button type="submit" className="login-button">
            Σύνδεση
          </button>
        </Form>
      </div>
    </div>
  );
}
